var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhiteScoreDiamond = function SvgWhiteScoreDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fffff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.999 24 0 11.676l5.197-5.331H18.8l5.2 5.33L11.999 24ZM1.336 11.676 12 22.63l10.665-10.953-4.255-4.361H5.588l-4.252 4.361Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.226 11.191h7.545v.97H8.226z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.55 23.467 7.886 12.161H.668v-.97h7.898l3.881 11.97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.447 23.467-.896-.306 3.88-11.97h7.901v.97h-7.22l-3.665 11.306ZM9.06 12.161H.668v-.97h6.724L4.988 7.079l.81-.5 3.262 5.582Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.63 6.527.738.606-3.774 4.845-.737-.605z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.826 12.524 11.63 7.132l.738-.605 3.348 4.301L18.2 6.58l.81.5zM11.528 0h.944v2.91h-.944V0Zm3.484.519.872.37-1.085 2.689-.872-.371L15.012.519Zm3.025 1.847.668.686-2.003 2.058-.668-.686 2.003-2.058ZM8.988.52l1.084 2.688-.872.371L8.116.89 8.988.52ZM5.963 2.367l2.003 2.058-.668.685-2.003-2.057.668-.686Z"
  }))));
};
export default SvgWhiteScoreDiamond;